var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":"","content-class":"custom-top-tooltip"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({staticClass:"mx-2",class:_vm.contentClass,attrs:{"small":_vm.small}},'v-icon',attrs,false),on),[_vm._v("mdi-progress-question")])]}}])},[_c('span',[_vm._t("text")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }